import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Create Audio
  audioCreateRequest: ['scriptId', 'options', 'callback'],
  audioCreateSuccess: ['data'],
  audioCreateFailure: ['error'],

  // Get Audio
  audioGetRequest: ['id', 'callback'],
  audioGetSuccess: ['data'],
  audioGetFailure: ['error'],

  // Get Audio Status
  audioStatusRequest: ['id', 'callback'],
  audioStatusSuccess: ['status'],
  audioStatusFailure: ['error'],

  // List Audios for Script
  audioListRequest: ['scriptId', 'callback'],
  audioListSuccess: ['list'],
  audioListFailure: ['error'],

  // Poll Audio Until Complete
  audioPollRequest: ['id', 'interval', 'callback'],
  audioPollSuccess: ['data'],
  audioPollFailure: ['error'],
  audioPollProgress: ['status'],

  // Generate Audio (create + poll)
  audioGenerateRequest: ['scriptId', 'options', 'callback'],
  audioGenerateSuccess: ['data'],
  audioGenerateFailure: ['error'],
  audioGenerateProgress: ['status'],

  // Set current audio
  setCurrentAudio: ['audio'],
  clearCurrentAudio: [],

  // Reset
  audioReset: [],
})

export const AudioTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Create
  createFetching: false,
  createError: null,
  createdData: null,

  // Get
  data: null,
  fetching: false,
  error: null,

  // List
  list: [],
  listFetching: false,
  listError: null,

  // Poll
  polling: false,
  pollStatus: null,
  pollError: null,

  // Generate (create + poll)
  generating: false,
  generateProgress: null,
  generateError: null,

  // Current audio
  currentAudio: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Create
    case Types.AUDIO_CREATE_REQUEST:
      return { ...state, createFetching: true, createError: null }
    case Types.AUDIO_CREATE_SUCCESS:
      return { ...state, createFetching: false, createError: null, createdData: action.data }
    case Types.AUDIO_CREATE_FAILURE:
      return { ...state, createFetching: false, createError: action.error }

    // Get
    case Types.AUDIO_GET_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.AUDIO_GET_SUCCESS:
      return { ...state, data: action.data, fetching: false, error: null }
    case Types.AUDIO_GET_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // Status
    case Types.AUDIO_STATUS_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.AUDIO_STATUS_SUCCESS:
      return { ...state, fetching: false, pollStatus: action.status }
    case Types.AUDIO_STATUS_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // List
    case Types.AUDIO_LIST_REQUEST:
      return { ...state, listFetching: true, listError: null }
    case Types.AUDIO_LIST_SUCCESS:
      return { ...state, list: action.list, listFetching: false, listError: null }
    case Types.AUDIO_LIST_FAILURE:
      return { ...state, listFetching: false, listError: action.error }

    // Poll
    case Types.AUDIO_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.AUDIO_POLL_SUCCESS:
      return { ...state, polling: false, data: action.data, pollError: null }
    case Types.AUDIO_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }
    case Types.AUDIO_POLL_PROGRESS:
      return { ...state, pollStatus: action.status }

    // Generate
    case Types.AUDIO_GENERATE_REQUEST:
      return { ...state, generating: true, generateError: null, generateProgress: null }
    case Types.AUDIO_GENERATE_SUCCESS:
      return { ...state, generating: false, data: action.data, generateError: null }
    case Types.AUDIO_GENERATE_FAILURE:
      return { ...state, generating: false, generateError: action.error }
    case Types.AUDIO_GENERATE_PROGRESS:
      return { ...state, generateProgress: action.status }

    // Current Audio
    case Types.SET_CURRENT_AUDIO:
      return { ...state, currentAudio: action.audio }
    case Types.CLEAR_CURRENT_AUDIO:
      return { ...state, currentAudio: null }

    // Reset
    case Types.AUDIO_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
